import { ChangeDetectionStrategy,Component, Optional ,Input,EventEmitter,Output,ChangeDetectorRef} from "@angular/core";
import { InvoiceAttachmentsDTO } from "@models/InvoiceAttachmentsDTO";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { WebResService } from '../service/webresservices';
import {saveAs as importedSaveAs} from "file-saver"; 
import { InvoiceViewModel } from "@models/InvoiceViewModel";

@Component({
    selector: "app-modal",
    styleUrls: ['../webres.scss'],
    templateUrl: "./downloadFile.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DownloadFileModalComponent {
  @Output() eventEmitter: EventEmitter<any> = new EventEmitter();
  @Input() invoiceid;
    private _messageBox: any;
    constructor( @Optional() private readonly activeModal: NgbActiveModal,private _webResService: WebResService, private _cd: ChangeDetectorRef) {
  }
  public invoiceId:any;
  public invs:Array<InvoiceViewModel> = [];
  public invoiceAttachment:any;
  public invoiceAttachmentWebForm:any;
  file:any;

  ngOnInit() {
    this._webResService.getFileAttachment(this.invoiceId).subscribe((data:Array<InvoiceAttachmentsDTO>) =>{
        this.invoiceAttachmentWebForm = data;
        if(this.invoiceAttachmentWebForm.length > 0){
            this.invoiceAttachmentWebForm.forEach(element => {
                this.invoiceAttachment = element.RawFileName;
                this.file =  this.invoiceAttachment ;
                console.log(this.invoiceAttachment);
                this._cd.detectChanges();
            });
        }else{
          this._messageBox.open("No Attachment!");
        }
      });
  }

  public downloadAttachment(attachment){
    this._webResService.getWebResAttachment(attachment.EncPath,"y",attachment.InvoiceId).subscribe((data) =>{
      importedSaveAs(data, attachment.RawFileName);
    });
  }

  public dismiss(): void {
    if (this.activeModal)
      this.activeModal.dismiss();
  } 
}
